export default __webpack_public_path__ + "static/media/screen11.77aac17f.png";